import { useCallback } from 'react';

import { GoalPrioritizeLimitReachedModal } from 'features/goal/components/PrioritizeLimitReachedModal';

import { modal, SIZES } from 'shared/components/Modal';

type UseOpenPrioritiesLimitReachedModalProps = {
  title: string;
  onSubmit: () => void;
};

export const useOpenPrioritizedGoalsLimitReachedModal = ({
  title,
  onSubmit,
}: UseOpenPrioritiesLimitReachedModalProps) =>
  useCallback(() => {
    modal.open({
      content: <GoalPrioritizeLimitReachedModal onSubmit={onSubmit} />,
      props: {
        size: SIZES.SM,
      },
      context: {
        title,
      },
    });
  }, [title, onSubmit]);
